module.exports = "tr.list { \n    height: auto;\n}\ntd { \n    width: 100%;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/rates/rates.component.css
// module id = ./src/app/rates/rates.component.css
// module chunks = main